<div class="file-chips">
  <div class="file-chip" [class.migrated]="file().confirmReuse">
    <comp-file-type [file]="file()"></comp-file-type>
    @if (isDownloadableStatus(file().fileStatus)) {
      <span class="downloadable-file-name">
        <button type="button" (click)="download(file().id!, file().filename)">
          {{ file().filename }}
        </button>
      </span>
    } @else {
      <span class="file-name">{{ file().filename }}</span>
    }
    <span class="file-dot" [class]="fileStatusClass(file().fileStatus)" aria-hidden="true"></span>
    @if (file().fileStatus === FileStatus.Uploading) {
      <span class="file-status-label">{{
        'requirementIntake.evidence.scan.uploading' | translate: { percentage: uploadPercentage() }
      }}</span>
      @if (uploadPercentage() > 0 && uploadPercentage() < 100) {
        <comp-progress-bar
          [showLabel]="false"
          [done]="uploadPercentage()"
          [total]="100"
        ></comp-progress-bar>
      }
    } @else if (file().confirmReuse) {
      {{ 'requirementIntake.evidence.slot.actions.confirmReuse' | translate }}
      <button comp-button="secondary" action="save" (click)="confirmReuse(file())">
        <i comp-icon>check</i>
        <span>{{ 'requirementIntake.evidence.slot.actions.confirmReuseButton' | translate }}</span>
      </button>
    } @else {
      <span
        class="file-status-label"
        [class.blink]="
          file().fileStatus === FileStatus.PendingScan ||
          file().fileStatus === FileStatus.PendingAnalysis
        "
        >{{ fileStatusLabelKey(file().fileStatus) | translate }}</span
      >
    }
    @if (isDeletableStatus(file().fileStatus)) {
      <button comp-button="secondary" [iconOnly]="true" (click)="onDeleteRequested(file())">
        <i comp-icon>delete</i>
      </button>
    }
  </div>
</div>
